<template>
  <div class="header-sub-nav" v-if="steps">
    <template
      v-for="step in steps"
      v-if="step.id >= startStepId && step.id <= endStepId"
    >
      <a :class="stepClass(step)" @click="goToStep(step)"
        ><span>{{ step.title }}</span></a
      >
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SHOW_FORM_ERRORS, HIDE_FORM_ERRORS } from "@/store/mutations.type";
import { GO_STEP } from "@/store/actions.type";
export default {
  name: "RoeNavigationHeader",
  props: {
    saveAction: {
      type: Function,
      required: true
    },
    changeRoute: {
      type: Function,
      required: true
    },
    startStepId: {
      type: Number,
      required: true
    },
    endStepId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(["steps", "currentStep", "invalidForm", "errorMessage"])
  },
  methods: {
    goToStep(step) {
      if (this.invalidForm) {
        this.$store.commit(SHOW_FORM_ERRORS);
        this.flashMessage.error({ title: "Error", message: this.errorMessage });
      } else if (this.$store.getters.canGoToStep(step)) {
        this.$store.dispatch(GO_STEP, step);
        this.$store.commit(HIDE_FORM_ERRORS);
        this.saveAction();
        this.changeRoute();
      }
    },
    stepClass(step) {
      if (step.id === this.currentStep.id) return "active";
      return step.state === "completed" ? "completed" : "";
    }
  }
};
</script>
